<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="domainData" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="platfromcode" label="平台编码" prop="platfromcode">
                    <a-input v-model="domainData.platfromcode" v-if="!is_vue_edit" @blur="
                        () => {
                            $refs.platfromcode.onFieldBlur();
                        }
                        " />
                    <span class="form_span" v-else>{{ domainData.platfromcode }}</span>
                </a-form-model-item>
                <a-form-model-item ref="username" label="用户名称" prop="username">
                    <a-input v-model="domainData.username" @blur="
                        () => {
                            $refs.username.onFieldBlur();
                        }
                        " />
                </a-form-model-item>
                <a-form-model-item ref="nickname" label="用户昵称" prop="nickname">
                    <a-input v-model="domainData.nickname" @blur="
                        () => {
                            $refs.nickname.onFieldBlur();
                        }
                        " />
                </a-form-model-item>

                <a-form-model-item ref="userstate" label="用户状态" prop="userstate">
                    <a-radio-group v-model="domainData.userstate" button-style="solid" style="margin-left:15px">
                        <a-radio-button value="1">正常</a-radio-button>
                        <a-radio-button value="2">禁用</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="identitytype" label="授权类型" prop="identitytype">
                    <a-radio-group v-model="domainData.identitytype" button-style="solid" style="margin-left:15px">
                        <a-radio-button value="1">账号密码</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>

                <a-form-model-item ref="identitykey" label="账户名称(账号)" prop="identitykey">
                    <a-input v-model="domainData.identitykey" @blur="
                        () => {
                            $refs.identitykey.onFieldBlur();
                        }
                        " />
                </a-form-model-item>
                <a-form-model-item ref="certificate" label="秘钥凭证(密码)" prop="certificate">
                    <a-input v-model="domainData.certificate" @blur="
                        () => {
                            $refs.certificate.onFieldBlur();
                        }
                        " password />
                </a-form-model-item>

                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    platfromadduser: '平台新增用户',
    platfromedituser: '平台修改用户',
}
var validatePass = (rule, value, callback) => {
    //必须包含⼤⼩写字母、数字、特殊字符长度再9-16位之间
    var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,20}')
    if (value === '') {
        callback(new Error('请输⼊密码'))
    } else if (value.length < 6 || value.length > 20) {
        callback(new Error('请输⼊6~20位密码'))
    } else if (!regex.test(value)) {
        callback(
            new Error('密码必须同时包含字母、数字和特殊字符其中三项且⾄少6位')
        )
    } else {
        callback()
    }
}

export default {
    data() {
        return {
            m_title,
            c_title: '',
            labelCol: { span: 6 },
            wrapperCol: { span: 8 },
            rules: {
                identitytype: [
                    {
                        required: true,
                        message: '请选择授权类型',
                        trigger: 'blur',
                    },
                ],

                platfromcode: [
                    {
                        required: true,
                        message: '请输入平台编码',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 50,
                        message: '请输入1~20个字符',
                        trigger: 'blur',
                    },
                ],
                platfromname: [
                    {
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 50,
                        message: '请输入1~20个字符',
                        trigger: 'blur',
                    },
                ],
                certificate: [
                    { required: true, message: '秘钥凭证', trigger: 'blur' },
                    {
                        min: 1,
                        max: 50,
                        message: '请输入1~50个字符',
                        trigger: 'blur',
                    },
                    {
                        required: true,
                        validator: validatePass,
                        trigger: 'blur',
                    },
                ],
                identitykey: [
                    {
                        required: true,
                        message: '请输入账户名称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 50,
                        message: '请输入1~50个字符',
                        trigger: 'blur',
                    },
                ],
                username: [
                    {
                        required: true,
                        message: '请输入用户名称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 10,
                        message: '请输入1~10个字符',
                        trigger: 'blur',
                    },
                ],
                nickname: [
                    {
                        required: true,
                        message: '请输入用户昵称',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 10,
                        message: '请输入1~10个字符',
                        trigger: 'blur',
                    },
                ],
                userstate: [
                    {
                        required: true,
                        message: '请选择用户状态',
                        trigger: 'blur',
                    },
                ],
            },
            confirmLoading: false,
            formItemLayout: 'horizontal',
            domainData: {},
            selecterState: {
                isShow: false,
                rowsType: 'radio', // or 'checkbox'，单选或多选
            },
            is_vue_edit: true,
            syslist: [],
        }
    },
    components: {},

    methods: {
        getSearchRoleConfig(platfromcode) {
            let c_params = {
                platfromcode: platfromcode,
                urlparams: false,
            }
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'ums/searchRoleConfig',
                    params: c_params,
                })
                .then((res) => {
                    console.log(res)
                    this.syslist = res.data.data
                })
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true
                    console.log(this.domainData)
                    const { params } = this.$route
                    if (
                        this.domainData.id &&
                        params.action != 'platfromadduser'
                    ) {
                        //编辑
                        this.$store
                            .dispatch({
                                type: 'ums/editPlatFromConfig',
                                params: this.domainData,
                            })
                            .then((response) => {
                                if (response.data.success == '1') {
                                    console.log(response)
                                    this.handleCancel()
                                    this.confirmLoading = false
                                }
                            })
                    } else {
                        let params = {
                            ...this.domainData,
                            registersource: 'fp-system',
                        }
                        //新增
                        this.$store
                            .dispatch({
                                type: 'ums/registerUser',
                                params: params,
                            })
                            .then((response) => {
                                console.log(response)
                                if (response.data.success == '1') {
                                    this.handleCancel()
                                }
                                this.confirmLoading = false
                            })
                    }
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },

        handleCancel() {
            this.resetForm()
            this.$router.back(-1)
        },
        resetForm() {
            this.$refs.ruleForm.resetFields()
        },
    },
    mounted() {
        const { query, params } = this.$route
        this.c_title = m_title[params.action]
        this.is_vue_edit = true //params.action != 'addPlatFrom';
        let that = this
        //数据初始化
        that.$store
            .dispatch({
                type: 'ums/selectPlatFromConfig',
                params: query,
            })
            .then((res) => {
                console.log(res)
                that.tLoading = false
                that.domainData = res.data.data[0]
                if (that.domainData.platfromcode != '') {
                    that.getSearchRoleConfig(that.domainData.platfromcode)
                }
            })
    },
}
</script>

<style lang="less" scoped>
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
